export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const generateRandomKey = (length: number) =>
  Array.from({ length }, () => '0123456789'[Math.floor(Math.random() * 10)]).join('');
